import { mergeClasses } from "@fluentui/react-components";
/**
 * Utility to merge two styles returned from the `useStyles` hook.
 * @param baseStyles Base styles for the merge
 * @param [overriddenStyles] Styles to be overridden
 * @returns Merged Styles
 */ export const customizeStyles = (baseStyles, overriddenStyles)=>{
    if (!overriddenStyles) {
        return baseStyles;
    }
    return Object.keys(baseStyles).reduce((prev, curr)=>{
        return {
            ...prev,
            [curr]: mergeClasses(baseStyles[curr], overriddenStyles[curr])
        };
    }, baseStyles);
};
